<template>
    <div>
        <b-form-group>Custom dataset</b-form-group>
        <b-button v-b-modal.uploadFile>
            <font-awesome-icon icon='file-upload'/>
            Upload
        </b-button>
        <div class="float-right">
            <em v-if="valid" class="text-muted">{{file.name}}</em>
            <em v-else class="text-muted">No file selected.</em>
            <b-button :disabled="valid !== true" variant="link" @click="clearFile">
                <font-awesome-icon icon="trash"></font-awesome-icon>
            </b-button>
        </div>
        <b-modal id="uploadFile" title="Dataset upload" size="lg" @cancel="clearFile" @ok="onSubmit">
            <b-form-group label="Please select a CSV file (plain text)" label-for="file-input">
                <b-form-file
                        id="file-input"
                        v-model="file"
                        :state="valid"
                        accept="text/*"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                ></b-form-file>
                <b-alert variant="danger" v-if="valid === false" class="my-2">{{ errorMessage }}</b-alert>
                <!--            Detail on accepted dataset format-->

            </b-form-group>
            <div v-if="loaded">
                <h3><small>File preview</small></h3>
                <b-table striped class="mini-table" borderless small responsive :items="items"></b-table>
                <h3><small>Column types</small></h3>
                <p>Columns are parsed as numerical value by default. Specify the columns that hold categorical data. The
                    list is already pre-filled.</p>
                <tag-input label="Select columns holding categorical data"
                           :initValue="suggestedCategories"
                           :options=header
                           v-on:input="updateCategories($event)"></tag-input>
                <h3><small>Other options</small></h3>
                <b-checkbox v-model="globalScale">Use a common range for all numerical axes</b-checkbox>
                <div v-if="globalScale" class="form-control h-auto">
                    <b-container>
                        <b-row>
                            <b-col sm="1">
                                <label :for="minValue">min:</label>
                            </b-col>
                            <b-col sm="3">
                                <b-form-input inline id="minValue" number v-model="minValue"></b-form-input>
                            </b-col>
                            <b-col sm="1">
                                <label :for="maxValue">max:</label>
                            </b-col>
                            <b-col sm="3">
                                <b-form-input inline id="maxValue" number v-model="maxValue"></b-form-input>
                            </b-col>
                        </b-row>
                    </b-container>
                    <small><em>Make sure the input range is larger than the actual range of numerical values in the
                        dataset.</em></small>

                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome/";
    import Papa from 'papaparse'
    import TagInput from "./TagInput";

    export default {
        name: "UploadModal",
        components: {
            TagInput,
            FontAwesomeIcon
        },
        data() {
            return {
                file: null,
                valid: null,
                loaded: false,
                items: [],
                header: [],
                nominalDimensions: [],
                hiddenDimensions: [],
                errorMessage: "",
                suggestedCategories: [],
                globalScale: false,
                minValue: 0,
                maxValue: 0,
                delimiter: ""
            }
        },
        methods: {
            clearFile() {
                this.valid = null
                this.items = []
                this.header = []
                this.nominalDimensions = []
                this.hiddenDimensions = []
                this.loaded = false
            },
            parseFile() {
                Papa.parse(this.file, {
                    header: true,
                    preview: 3,
                    complete: (results,) => {
                        if (results.meta.fields.length < 3) {
                            this.valid = false
                            this.errorMessage = "The file should contain more than 2 columns"
                        } else {
                            this.loaded = true
                            this.items = results.data
                            this.header = results.meta.fields
                            this.valid = true
                            this.delimiter = results.meta.delimiter
                            this.suggestedCategories = this.header.filter(e => isNaN(parseFloat(this.items[0][e])))
                        }
                    },
                    error: function (err, file, inputElem, reason) {
                        console.log(err, file, inputElem, reason) // TODO : fix error handling
                    },
                })
            },
            onSubmit() {
                // Validate options, send event
                // Once valid, copy file to local FS or load it as string for core?
                if (this.file && this.valid) {
                    let options = {
                        "name": this.file.name,
                        "description": "Imported dataset (filename: " + this.file.name + ")",
                        "nominalDimensions": this.nominalDimensions,
                        "hiddenDimensions": [],
                        "ordinalDimensions": [],
                        "minValue": this.globalScale ? this.minValue : Infinity,
                        "maxValue": this.globalScale ? this.maxValue : Infinity,
                        "url": null,
                        "delimiter": this.delimiter,
                        "withHeader": true
                    }
                    this.$parent.$emit('input', {file: this.file, options: options});
                } else {
                    this.clearFile()
                }

            },
            updateCategories(columnList) {
                this.nominalDimensions = columnList
            }

        },
        watch: {
            file() {
                this.clearFile()
                this.parseFile()
            }
        },
        computed: {
            displayedDimensions() {
                return this.header.filter(i => !this.hiddenDimensions.includes(i))
            },
            validMinMaxValues() {
                return !isNaN(this.minValue) && !isNaN(this.maxValue) && this.minValue < this.maxValue
            }
        }
    }
</script>

<style scoped>
    .mini-table {
        font-size: 0.7rem;
        border-color: #4f5b69;
        font-family: monospace;
    }
</style>
